// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/functions/v1/functions.proto" (package "c1.api.functions.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../../google/protobuf/struct";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Function represents a customer-provided code extension in the API
 *
 * @generated from protobuf message c1.api.functions.v1.Function
 */
export interface Function {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 5
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 6
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionType function_type = 7
     */
    functionType: FunctionType;
    /**
     * @generated from protobuf field: string published_commit_id = 8
     */
    publishedCommitId: string;
    /**
     * @generated from protobuf field: string head = 9
     */
    head: string;
    /**
     * @generated from protobuf field: bool is_draft = 10
     */
    isDraft: boolean;
    /**
     * @generated from protobuf field: map<string, string> secret = 11
     */
    secret: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: repeated string outbound_network_allowlist = 12
     */
    outboundNetworkAllowlist: string[];
    /**
     * Scoped role IDs define the permissions granted to this function when calling
     * ConductorOne APIs. These are role IDs (not service roles) that get resolved
     * to their service roles at authentication time.
     *
     * Currently only the "Read-Only Administrator" role (system:viewer) is supported.
     * The role ID can be obtained from the roles API.
     *
     * @generated from protobuf field: repeated string scoped_role_ids = 13
     */
    scopedRoleIds: string[];
}
/**
 * FunctionRef is a lightweight reference to a Function
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionRef
 */
export interface FunctionRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionCommitRef
 */
export interface FunctionCommitRef {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionInvocationRef
 */
export interface FunctionInvocationRef {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionLogRef
 */
export interface FunctionLogRef {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string invocation_id = 2
     */
    invocationId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * FunctionCommit represents a single commit in a function's history
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionCommit
 */
export interface FunctionCommit {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string author = 3
     */
    author: string;
    /**
     * @generated from protobuf field: string message = 4
     */
    message: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsSearchRequest
 */
export interface FunctionsSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionType function_types = 2
     */
    functionTypes: FunctionType[];
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsSearchResponse
 */
export interface FunctionsSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.Function list = 1
     */
    list: Function[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionRequest
 */
export interface FunctionsExecutorServiceGetFunctionRequest {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionResponse
 */
export interface FunctionsExecutorServiceGetFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1
     */
    function?: Function;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigRequest
 */
export interface FunctionsExecutorServiceGetFunctionConfigRequest {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigResponse
 */
export interface FunctionsExecutorServiceGetFunctionConfigResponse {
    /**
     * @generated from protobuf field: bytes encrypted_function_config = 1
     */
    encryptedFunctionConfig: Uint8Array;
    /**
     * @generated from protobuf field: repeated string outbound_network_allowlist = 2
     */
    outboundNetworkAllowlist: string[];
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionRequest
 */
export interface FunctionsServiceGetFunctionRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionResponse
 */
export interface FunctionsServiceGetFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1
     */
    function?: Function;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionRequest
 */
export interface FunctionsServiceDeleteFunctionRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * Empty response
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionResponse
 */
export interface FunctionsServiceDeleteFunctionResponse {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsRequest
 */
export interface FunctionsServiceListFunctionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsResponse
 */
export interface FunctionsServiceListFunctionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.Function list = 1
     */
    list: Function[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionRequest
 */
export interface FunctionsServiceCreateFunctionRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionType function_type = 3
     */
    functionType: FunctionType;
    /**
     * @generated from protobuf field: map<string, bytes> initial_content = 4
     */
    initialContent: {
        [key: string]: Uint8Array;
    };
    /**
     * @generated from protobuf field: string commit_message = 5
     */
    commitMessage: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionResponse
 */
export interface FunctionsServiceCreateFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1
     */
    function?: Function;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 2
     */
    commit?: FunctionCommit;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionRequest
 */
export interface FunctionsServiceUpdateFunctionRequest {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1
     */
    function?: Function;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionResponse
 */
export interface FunctionsServiceUpdateFunctionResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.Function function = 1
     */
    function?: Function;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyRequest
 */
export interface FunctionsServiceGetFunctionSecretEncryptionKeyRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyResponse
 */
export interface FunctionsServiceGetFunctionSecretEncryptionKeyResponse {
    /**
     * @generated from protobuf field: bytes public_key = 1
     */
    publicKey: Uint8Array; // JWK-formatted public key for encrypting secrets
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitRequest
 */
export interface FunctionsExecutorServiceGetCommitRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitResponse
 */
export interface FunctionsExecutorServiceGetCommitResponse {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "commit";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 1
         */
        commit: FunctionCommit;
    } | {
        oneofKind: "fileChunk";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FileChunk file_chunk = 2
         */
        fileChunk: FileChunk;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionLog
 */
export interface FunctionLog {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionLogLevel level = 3
     */
    level: FunctionLogLevel;
    /**
     * @generated from protobuf field: string message = 4
     */
    message: string;
    /**
     * @generated from protobuf field: int64 sequence = 5
     */
    sequence: number;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest
 */
export interface FunctionsExecutorServiceUpdateLogsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry logs = 1
     */
    logs: FunctionsExecutorServiceUpdateLogsRequest_LogEntry[];
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry
 */
export interface FunctionsExecutorServiceUpdateLogsRequest_LogEntry {
    /**
     * @generated from protobuf field: string invocation_id = 1
     */
    invocationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionLogLevel level = 3
     */
    level: FunctionLogLevel;
    /**
     * @generated from protobuf field: string message = 4
     */
    message: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsResponse
 */
export interface FunctionsExecutorServiceUpdateLogsResponse {
    /**
     * @generated from protobuf field: bool acknowledged = 1
     */
    acknowledged: boolean;
    /**
     * @generated from protobuf field: int32 logs_received = 2
     */
    logsReceived: number;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsRequest
 */
export interface FunctionsInvocationServiceListLogsRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string invocation_id = 2
     */
    invocationId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsResponse
 */
export interface FunctionsInvocationServiceListLogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionLog list = 1
     */
    list: FunctionLog[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetCommitRequest
 */
export interface FunctionsServiceGetCommitRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceGetCommitResponse
 */
export interface FunctionsServiceGetCommitResponse {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "commit";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 1
         */
        commit: FunctionCommit;
    } | {
        oneofKind: "fileChunk";
        /**
         * @generated from protobuf field: c1.api.functions.v1.FileChunk file_chunk = 2
         */
        fileChunk: FileChunk;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FileChunk
 */
export interface FileChunk {
    /**
     * @generated from protobuf field: string filename = 1
     */
    filename: string;
    /**
     * @generated from protobuf field: bytes data = 2
     */
    data: Uint8Array;
    /**
     * @generated from protobuf field: bool is_last_chunk = 3
     */
    isLastChunk: boolean;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitRequest
 */
export interface FunctionsServiceCreateInitialCommitRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: repeated string filenames = 2
     */
    filenames: string[]; // list of filenames to upload
    /**
     * @generated from protobuf field: string commit_message = 3
     */
    commitMessage: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse
 */
export interface FunctionsServiceCreateInitialCommitResponse {
    /**
     * @generated from protobuf field: string commit_id = 1
     */
    commitId: string;
    /**
     * @generated from protobuf field: map<string, string> upload_urls = 2
     */
    uploadUrls: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitRequest
 */
export interface FunctionsServiceCreateFinalCommitRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 2
     */
    commitId: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitResponse
 */
export interface FunctionsServiceCreateFinalCommitResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionCommit commit = 1
     */
    commit?: FunctionCommit;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListCommitsRequest
 */
export interface FunctionsServiceListCommitsRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListCommitsResponse
 */
export interface FunctionsServiceListCommitsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionCommit list = 1
     */
    list: FunctionCommit[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateTagRequest
 */
export interface FunctionsServiceCreateTagRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 2
     */
    commitId: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceCreateTagResponse
 */
export interface FunctionsServiceCreateTagResponse {
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListTagsRequest
 */
export interface FunctionsServiceListTagsRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceListTagsResponse
 */
export interface FunctionsServiceListTagsResponse {
    /**
     * @generated from protobuf field: map<string, c1.api.functions.v1.FunctionCommit> tags = 1
     */
    tags: {
        [key: string]: FunctionCommit;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceInvokeRequest
 */
export interface FunctionsServiceInvokeRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 2
     */
    commitId: string;
    /**
     * @generated from protobuf oneof: arg
     */
    arg: {
        oneofKind: "json";
        /**
         * @generated from protobuf field: bytes json = 100
         */
        json: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsServiceInvokeResponse
 */
export interface FunctionsServiceInvokeResponse {
    /**
     * @generated from protobuf field: string invocation_id = 1
     */
    invocationId: string;
    /**
     * @generated from protobuf oneof: resp
     */
    resp: {
        oneofKind: "json";
        /**
         * @deprecated
         * @generated from protobuf field: bytes json = 100 [deprecated = true]
         */
        json: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListRequest
 */
export interface FunctionsInvocationServiceListRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceListResponse
 */
export interface FunctionsInvocationServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionInvocation list = 1
     */
    list: FunctionInvocation[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetRequest
 */
export interface FunctionsInvocationServiceGetRequest {
    /**
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetResponse
 */
export interface FunctionsInvocationServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionInvocation invocation = 1
     */
    invocation?: FunctionInvocation;
}
/**
 * @generated from protobuf message c1.api.functions.v1.FunctionInvocation
 */
export interface FunctionInvocation {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string function_id = 2
     */
    functionId: string;
    /**
     * @generated from protobuf field: string commit_id = 3
     */
    commitId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct input = 6
     */
    input?: Struct;
    /**
     * @generated from protobuf field: google.protobuf.Struct output = 7
     */
    output?: Struct;
    /**
     * @generated from protobuf field: c1.api.functions.v1.FunctionInvocationStatus status = 8
     */
    status: FunctionInvocationStatus;
    /**
     * @generated from protobuf field: string error = 9
     */
    error: string;
}
/**
 * FunctionsInvocationSearchRequest is the request for searching function invocations.
 * Results are returned in descending order by created_at (newest first).
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationSearchRequest
 */
export interface FunctionsInvocationSearchRequest {
    /**
     * The function ID to search invocations for.
     *
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * The number of results to return per page.
     *
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * The pagination token for fetching the next page.
     *
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * FunctionsInvocationSearchResponse is the response for searching function invocations.
 *
 * @generated from protobuf message c1.api.functions.v1.FunctionsInvocationSearchResponse
 */
export interface FunctionsInvocationSearchResponse {
    /**
     * The list of function invocations, ordered by created_at descending.
     *
     * @generated from protobuf field: repeated c1.api.functions.v1.FunctionInvocation list = 1
     */
    list: FunctionInvocation[];
    /**
     * The pagination token for fetching the next page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Function types match the model representation
 *
 * @generated from protobuf enum c1.api.functions.v1.FunctionType
 */
export enum FunctionType {
    /**
     * @generated from protobuf enum value: FUNCTION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FUNCTION_TYPE_ANY = 1;
     */
    ANY = 1
}
/**
 * @generated from protobuf enum c1.api.functions.v1.FunctionLogLevel
 */
export enum FunctionLogLevel {
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_INFO = 1;
     */
    INFO = 1,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_WARN = 2;
     */
    WARN = 2,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: FUNCTION_LOG_LEVEL_DEBUG = 4;
     */
    DEBUG = 4
}
/**
 * @generated from protobuf enum c1.api.functions.v1.FunctionInvocationStatus
 */
export enum FunctionInvocationStatus {
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_SUCCESS = 3;
     */
    SUCCESS = 3,
    /**
     * @generated from protobuf enum value: FUNCTION_INVOCATION_STATUS_ERROR = 4;
     */
    ERROR = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class Function$Type extends MessageType<Function> {
    constructor() {
        super("c1.api.functions.v1.Function", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 7, name: "function_type", kind: "enum", T: () => ["c1.api.functions.v1.FunctionType", FunctionType, "FUNCTION_TYPE_"] },
            { no: 8, name: "published_commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "head", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "secret", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "validate.rules": { map: { minPairs: "0", maxPairs: "32", keys: { string: { minBytes: "1", maxBytes: "256", pattern: "^[a-zA-Z0-9_]+$" } }, values: { string: { maxBytes: "4096" } } } } } },
            { no: 12, name: "outbound_network_allowlist", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { minBytes: "1", maxBytes: "2048", pattern: "^((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|(\\d{1,3}(\\.\\d{1,3}){3})):([1-9]\\d{0,3}|[1-5]\\d{4}|6[0-4]\\d{3}|65[0-4]\\d{2}|655[0-2]\\d|6553[0-5])$" } } } } } },
            { no: 13, name: "scoped_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { minBytes: "1", maxBytes: "256" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Function" } }] }, "policy.v1.msg": { enabled: true, name: "function", keyFields: ["id"] } });
    }
    create(value?: PartialMessage<Function>): Function {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.functionType = 0;
        message.publishedCommitId = "";
        message.head = "";
        message.isDraft = false;
        message.secret = {};
        message.outboundNetworkAllowlist = [];
        message.scopedRoleIds = [];
        if (value !== undefined)
            reflectionMergePartial<Function>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Function): Function {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 4:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 5:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* c1.api.functions.v1.FunctionType function_type */ 7:
                    message.functionType = reader.int32();
                    break;
                case /* string published_commit_id */ 8:
                    message.publishedCommitId = reader.string();
                    break;
                case /* string head */ 9:
                    message.head = reader.string();
                    break;
                case /* bool is_draft */ 10:
                    message.isDraft = reader.bool();
                    break;
                case /* map<string, string> secret */ 11:
                    this.binaryReadMap11(message.secret, reader, options);
                    break;
                case /* repeated string outbound_network_allowlist */ 12:
                    message.outboundNetworkAllowlist.push(reader.string());
                    break;
                case /* repeated string scoped_role_ids */ 13:
                    message.scopedRoleIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap11(map: Function["secret"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Function["secret"] | undefined, val: Function["secret"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.functions.v1.Function.secret");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Function, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 4; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 5; */
        if (message.displayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.displayName);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* c1.api.functions.v1.FunctionType function_type = 7; */
        if (message.functionType !== 0)
            writer.tag(7, WireType.Varint).int32(message.functionType);
        /* string published_commit_id = 8; */
        if (message.publishedCommitId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.publishedCommitId);
        /* string head = 9; */
        if (message.head !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.head);
        /* bool is_draft = 10; */
        if (message.isDraft !== false)
            writer.tag(10, WireType.Varint).bool(message.isDraft);
        /* map<string, string> secret = 11; */
        for (let k of globalThis.Object.keys(message.secret))
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.secret[k]).join();
        /* repeated string outbound_network_allowlist = 12; */
        for (let i = 0; i < message.outboundNetworkAllowlist.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.outboundNetworkAllowlist[i]);
        /* repeated string scoped_role_ids = 13; */
        for (let i = 0; i < message.scopedRoleIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.scopedRoleIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.Function
 */
export const Function = new Function$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionRef$Type extends MessageType<FunctionRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionRef>): FunctionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionRef): FunctionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionRef
 */
export const FunctionRef = new FunctionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionCommitRef$Type extends MessageType<FunctionCommitRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionCommitRef", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionCommitRef>): FunctionCommitRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionCommitRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionCommitRef): FunctionCommitRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionCommitRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionCommitRef
 */
export const FunctionCommitRef = new FunctionCommitRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionInvocationRef$Type extends MessageType<FunctionInvocationRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionInvocationRef", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionInvocationRef>): FunctionInvocationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionInvocationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionInvocationRef): FunctionInvocationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionInvocationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionInvocationRef
 */
export const FunctionInvocationRef = new FunctionInvocationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionLogRef$Type extends MessageType<FunctionLogRef> {
    constructor() {
        super("c1.api.functions.v1.FunctionLogRef", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionLogRef>): FunctionLogRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.invocationId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionLogRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionLogRef): FunctionLogRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string invocation_id */ 2:
                    message.invocationId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionLogRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string invocation_id = 2; */
        if (message.invocationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invocationId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionLogRef
 */
export const FunctionLogRef = new FunctionLogRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionCommit$Type extends MessageType<FunctionCommit> {
    constructor() {
        super("c1.api.functions.v1.FunctionCommit", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "author", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<FunctionCommit>): FunctionCommit {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.id = "";
        message.author = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionCommit>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionCommit): FunctionCommit {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string author */ 3:
                    message.author = reader.string();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionCommit, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string author = 3; */
        if (message.author !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.author);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionCommit
 */
export const FunctionCommit = new FunctionCommit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsSearchRequest$Type extends MessageType<FunctionsSearchRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 2, name: "function_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.functions.v1.FunctionType", FunctionType, "FUNCTION_TYPE_"] },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsSearchRequest>): FunctionsSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.functionTypes = [];
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsSearchRequest): FunctionsSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.functions.v1.FunctionType function_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.functionTypes.push(reader.int32());
                    else
                        message.functionTypes.push(reader.int32());
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.functions.v1.FunctionType function_types = 2; */
        if (message.functionTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.functionTypes.length; i++)
                writer.int32(message.functionTypes[i]);
            writer.join();
        }
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsSearchRequest
 */
export const FunctionsSearchRequest = new FunctionsSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsSearchResponse$Type extends MessageType<FunctionsSearchResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Function },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsSearchResponse>): FunctionsSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsSearchResponse): FunctionsSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.Function list */ 1:
                    message.list.push(Function.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.Function list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Function.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsSearchResponse
 */
export const FunctionsSearchResponse = new FunctionsSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionRequest$Type extends MessageType<FunctionsExecutorServiceGetFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionRequest", []);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceGetFunctionRequest>): FunctionsExecutorServiceGetFunctionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceGetFunctionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceGetFunctionRequest): FunctionsExecutorServiceGetFunctionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceGetFunctionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionRequest
 */
export const FunctionsExecutorServiceGetFunctionRequest = new FunctionsExecutorServiceGetFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionResponse$Type extends MessageType<FunctionsExecutorServiceGetFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceGetFunctionResponse>): FunctionsExecutorServiceGetFunctionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceGetFunctionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceGetFunctionResponse): FunctionsExecutorServiceGetFunctionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.Function function */ 1:
                    message.function = Function.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceGetFunctionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.Function function = 1; */
        if (message.function)
            Function.internalBinaryWrite(message.function, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionResponse
 */
export const FunctionsExecutorServiceGetFunctionResponse = new FunctionsExecutorServiceGetFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionConfigRequest$Type extends MessageType<FunctionsExecutorServiceGetFunctionConfigRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigRequest", []);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceGetFunctionConfigRequest>): FunctionsExecutorServiceGetFunctionConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceGetFunctionConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceGetFunctionConfigRequest): FunctionsExecutorServiceGetFunctionConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceGetFunctionConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigRequest
 */
export const FunctionsExecutorServiceGetFunctionConfigRequest = new FunctionsExecutorServiceGetFunctionConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetFunctionConfigResponse$Type extends MessageType<FunctionsExecutorServiceGetFunctionConfigResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigResponse", [
            { no: 1, name: "encrypted_function_config", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "outbound_network_allowlist", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceGetFunctionConfigResponse>): FunctionsExecutorServiceGetFunctionConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptedFunctionConfig = new Uint8Array(0);
        message.outboundNetworkAllowlist = [];
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceGetFunctionConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceGetFunctionConfigResponse): FunctionsExecutorServiceGetFunctionConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes encrypted_function_config */ 1:
                    message.encryptedFunctionConfig = reader.bytes();
                    break;
                case /* repeated string outbound_network_allowlist */ 2:
                    message.outboundNetworkAllowlist.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceGetFunctionConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes encrypted_function_config = 1; */
        if (message.encryptedFunctionConfig.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.encryptedFunctionConfig);
        /* repeated string outbound_network_allowlist = 2; */
        for (let i = 0; i < message.outboundNetworkAllowlist.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.outboundNetworkAllowlist[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetFunctionConfigResponse
 */
export const FunctionsExecutorServiceGetFunctionConfigResponse = new FunctionsExecutorServiceGetFunctionConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionRequest$Type extends MessageType<FunctionsServiceGetFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceGetFunctionRequest>): FunctionsServiceGetFunctionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceGetFunctionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceGetFunctionRequest): FunctionsServiceGetFunctionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceGetFunctionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionRequest
 */
export const FunctionsServiceGetFunctionRequest = new FunctionsServiceGetFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionResponse$Type extends MessageType<FunctionsServiceGetFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceGetFunctionResponse>): FunctionsServiceGetFunctionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceGetFunctionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceGetFunctionResponse): FunctionsServiceGetFunctionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.Function function */ 1:
                    message.function = Function.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceGetFunctionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.Function function = 1; */
        if (message.function)
            Function.internalBinaryWrite(message.function, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionResponse
 */
export const FunctionsServiceGetFunctionResponse = new FunctionsServiceGetFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceDeleteFunctionRequest$Type extends MessageType<FunctionsServiceDeleteFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceDeleteFunctionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceDeleteFunctionRequest>): FunctionsServiceDeleteFunctionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceDeleteFunctionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceDeleteFunctionRequest): FunctionsServiceDeleteFunctionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceDeleteFunctionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionRequest
 */
export const FunctionsServiceDeleteFunctionRequest = new FunctionsServiceDeleteFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceDeleteFunctionResponse$Type extends MessageType<FunctionsServiceDeleteFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceDeleteFunctionResponse", []);
    }
    create(value?: PartialMessage<FunctionsServiceDeleteFunctionResponse>): FunctionsServiceDeleteFunctionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceDeleteFunctionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceDeleteFunctionResponse): FunctionsServiceDeleteFunctionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceDeleteFunctionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceDeleteFunctionResponse
 */
export const FunctionsServiceDeleteFunctionResponse = new FunctionsServiceDeleteFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListFunctionsRequest$Type extends MessageType<FunctionsServiceListFunctionsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListFunctionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceListFunctionsRequest>): FunctionsServiceListFunctionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceListFunctionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceListFunctionsRequest): FunctionsServiceListFunctionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceListFunctionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsRequest
 */
export const FunctionsServiceListFunctionsRequest = new FunctionsServiceListFunctionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListFunctionsResponse$Type extends MessageType<FunctionsServiceListFunctionsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListFunctionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Function },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceListFunctionsResponse>): FunctionsServiceListFunctionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceListFunctionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceListFunctionsResponse): FunctionsServiceListFunctionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.Function list */ 1:
                    message.list.push(Function.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceListFunctionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.Function list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Function.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListFunctionsResponse
 */
export const FunctionsServiceListFunctionsResponse = new FunctionsServiceListFunctionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFunctionRequest$Type extends MessageType<FunctionsServiceCreateFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFunctionRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "function_type", kind: "enum", T: () => ["c1.api.functions.v1.FunctionType", FunctionType, "FUNCTION_TYPE_"] },
            { no: 4, name: "initial_content", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 12 /*ScalarType.BYTES*/ } },
            { no: 5, name: "commit_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateFunctionRequest>): FunctionsServiceCreateFunctionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.functionType = 0;
        message.initialContent = {};
        message.commitMessage = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateFunctionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateFunctionRequest): FunctionsServiceCreateFunctionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.functions.v1.FunctionType function_type */ 3:
                    message.functionType = reader.int32();
                    break;
                case /* map<string, bytes> initial_content */ 4:
                    this.binaryReadMap4(message.initialContent, reader, options);
                    break;
                case /* string commit_message */ 5:
                    message.commitMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: FunctionsServiceCreateFunctionRequest["initialContent"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FunctionsServiceCreateFunctionRequest["initialContent"] | undefined, val: FunctionsServiceCreateFunctionRequest["initialContent"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bytes();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.functions.v1.FunctionsServiceCreateFunctionRequest.initial_content");
            }
        }
        map[key ?? ""] = val ?? new Uint8Array(0);
    }
    internalBinaryWrite(message: FunctionsServiceCreateFunctionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.functions.v1.FunctionType function_type = 3; */
        if (message.functionType !== 0)
            writer.tag(3, WireType.Varint).int32(message.functionType);
        /* map<string, bytes> initial_content = 4; */
        for (let k of globalThis.Object.keys(message.initialContent))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).bytes(message.initialContent[k]).join();
        /* string commit_message = 5; */
        if (message.commitMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.commitMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionRequest
 */
export const FunctionsServiceCreateFunctionRequest = new FunctionsServiceCreateFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFunctionResponse$Type extends MessageType<FunctionsServiceCreateFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function },
            { no: 2, name: "commit", kind: "message", T: () => FunctionCommit }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateFunctionResponse>): FunctionsServiceCreateFunctionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateFunctionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateFunctionResponse): FunctionsServiceCreateFunctionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.Function function */ 1:
                    message.function = Function.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                case /* c1.api.functions.v1.FunctionCommit commit */ 2:
                    message.commit = FunctionCommit.internalBinaryRead(reader, reader.uint32(), options, message.commit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceCreateFunctionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.Function function = 1; */
        if (message.function)
            Function.internalBinaryWrite(message.function, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.functions.v1.FunctionCommit commit = 2; */
        if (message.commit)
            FunctionCommit.internalBinaryWrite(message.commit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFunctionResponse
 */
export const FunctionsServiceCreateFunctionResponse = new FunctionsServiceCreateFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceUpdateFunctionRequest$Type extends MessageType<FunctionsServiceUpdateFunctionRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceUpdateFunctionRequest", [
            { no: 1, name: "function", kind: "message", T: () => Function },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceUpdateFunctionRequest>): FunctionsServiceUpdateFunctionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceUpdateFunctionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceUpdateFunctionRequest): FunctionsServiceUpdateFunctionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.Function function */ 1:
                    message.function = Function.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceUpdateFunctionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.Function function = 1; */
        if (message.function)
            Function.internalBinaryWrite(message.function, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionRequest
 */
export const FunctionsServiceUpdateFunctionRequest = new FunctionsServiceUpdateFunctionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceUpdateFunctionResponse$Type extends MessageType<FunctionsServiceUpdateFunctionResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceUpdateFunctionResponse", [
            { no: 1, name: "function", kind: "message", T: () => Function }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceUpdateFunctionResponse>): FunctionsServiceUpdateFunctionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceUpdateFunctionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceUpdateFunctionResponse): FunctionsServiceUpdateFunctionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.Function function */ 1:
                    message.function = Function.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceUpdateFunctionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.Function function = 1; */
        if (message.function)
            Function.internalBinaryWrite(message.function, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceUpdateFunctionResponse
 */
export const FunctionsServiceUpdateFunctionResponse = new FunctionsServiceUpdateFunctionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionSecretEncryptionKeyRequest$Type extends MessageType<FunctionsServiceGetFunctionSecretEncryptionKeyRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceGetFunctionSecretEncryptionKeyRequest>): FunctionsServiceGetFunctionSecretEncryptionKeyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceGetFunctionSecretEncryptionKeyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceGetFunctionSecretEncryptionKeyRequest): FunctionsServiceGetFunctionSecretEncryptionKeyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceGetFunctionSecretEncryptionKeyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyRequest
 */
export const FunctionsServiceGetFunctionSecretEncryptionKeyRequest = new FunctionsServiceGetFunctionSecretEncryptionKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetFunctionSecretEncryptionKeyResponse$Type extends MessageType<FunctionsServiceGetFunctionSecretEncryptionKeyResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyResponse", [
            { no: 1, name: "public_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceGetFunctionSecretEncryptionKeyResponse>): FunctionsServiceGetFunctionSecretEncryptionKeyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.publicKey = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceGetFunctionSecretEncryptionKeyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceGetFunctionSecretEncryptionKeyResponse): FunctionsServiceGetFunctionSecretEncryptionKeyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes public_key */ 1:
                    message.publicKey = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceGetFunctionSecretEncryptionKeyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes public_key = 1; */
        if (message.publicKey.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.publicKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetFunctionSecretEncryptionKeyResponse
 */
export const FunctionsServiceGetFunctionSecretEncryptionKeyResponse = new FunctionsServiceGetFunctionSecretEncryptionKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetCommitRequest$Type extends MessageType<FunctionsExecutorServiceGetCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetCommitRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceGetCommitRequest>): FunctionsExecutorServiceGetCommitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceGetCommitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceGetCommitRequest): FunctionsExecutorServiceGetCommitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceGetCommitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitRequest
 */
export const FunctionsExecutorServiceGetCommitRequest = new FunctionsExecutorServiceGetCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceGetCommitResponse$Type extends MessageType<FunctionsExecutorServiceGetCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceGetCommitResponse", [
            { no: 1, name: "commit", kind: "message", oneof: "message", T: () => FunctionCommit },
            { no: 2, name: "file_chunk", kind: "message", oneof: "message", T: () => FileChunk }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceGetCommitResponse>): FunctionsExecutorServiceGetCommitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceGetCommitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceGetCommitResponse): FunctionsExecutorServiceGetCommitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.FunctionCommit commit */ 1:
                    message.message = {
                        oneofKind: "commit",
                        commit: FunctionCommit.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).commit)
                    };
                    break;
                case /* c1.api.functions.v1.FileChunk file_chunk */ 2:
                    message.message = {
                        oneofKind: "fileChunk",
                        fileChunk: FileChunk.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).fileChunk)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceGetCommitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.FunctionCommit commit = 1; */
        if (message.message.oneofKind === "commit")
            FunctionCommit.internalBinaryWrite(message.message.commit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.functions.v1.FileChunk file_chunk = 2; */
        if (message.message.oneofKind === "fileChunk")
            FileChunk.internalBinaryWrite(message.message.fileChunk, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceGetCommitResponse
 */
export const FunctionsExecutorServiceGetCommitResponse = new FunctionsExecutorServiceGetCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionLog$Type extends MessageType<FunctionLog> {
    constructor() {
        super("c1.api.functions.v1.FunctionLog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "level", kind: "enum", T: () => ["c1.api.functions.v1.FunctionLogLevel", FunctionLogLevel, "FUNCTION_LOG_LEVEL_"] },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sequence", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionLog>): FunctionLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.level = 0;
        message.message = "";
        message.sequence = 0;
        if (value !== undefined)
            reflectionMergePartial<FunctionLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionLog): FunctionLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* c1.api.functions.v1.FunctionLogLevel level */ 3:
                    message.level = reader.int32();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                case /* int64 sequence */ 5:
                    message.sequence = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.functions.v1.FunctionLogLevel level = 3; */
        if (message.level !== 0)
            writer.tag(3, WireType.Varint).int32(message.level);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        /* int64 sequence = 5; */
        if (message.sequence !== 0)
            writer.tag(5, WireType.Varint).int64(message.sequence);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionLog
 */
export const FunctionLog = new FunctionLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceUpdateLogsRequest$Type extends MessageType<FunctionsExecutorServiceUpdateLogsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionsExecutorServiceUpdateLogsRequest_LogEntry, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceUpdateLogsRequest>): FunctionsExecutorServiceUpdateLogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.logs = [];
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceUpdateLogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceUpdateLogsRequest): FunctionsExecutorServiceUpdateLogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry logs */ 1:
                    message.logs.push(FunctionsExecutorServiceUpdateLogsRequest_LogEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceUpdateLogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry logs = 1; */
        for (let i = 0; i < message.logs.length; i++)
            FunctionsExecutorServiceUpdateLogsRequest_LogEntry.internalBinaryWrite(message.logs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest
 */
export const FunctionsExecutorServiceUpdateLogsRequest = new FunctionsExecutorServiceUpdateLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceUpdateLogsRequest_LogEntry$Type extends MessageType<FunctionsExecutorServiceUpdateLogsRequest_LogEntry> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry", [
            { no: 1, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "level", kind: "enum", T: () => ["c1.api.functions.v1.FunctionLogLevel", FunctionLogLevel, "FUNCTION_LOG_LEVEL_"] },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "65536" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceUpdateLogsRequest_LogEntry>): FunctionsExecutorServiceUpdateLogsRequest_LogEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.invocationId = "";
        message.level = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceUpdateLogsRequest_LogEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceUpdateLogsRequest_LogEntry): FunctionsExecutorServiceUpdateLogsRequest_LogEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string invocation_id */ 1:
                    message.invocationId = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* c1.api.functions.v1.FunctionLogLevel level */ 3:
                    message.level = reader.int32();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceUpdateLogsRequest_LogEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string invocation_id = 1; */
        if (message.invocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.invocationId);
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.functions.v1.FunctionLogLevel level = 3; */
        if (message.level !== 0)
            writer.tag(3, WireType.Varint).int32(message.level);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsRequest.LogEntry
 */
export const FunctionsExecutorServiceUpdateLogsRequest_LogEntry = new FunctionsExecutorServiceUpdateLogsRequest_LogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsExecutorServiceUpdateLogsResponse$Type extends MessageType<FunctionsExecutorServiceUpdateLogsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsResponse", [
            { no: 1, name: "acknowledged", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "logs_received", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsExecutorServiceUpdateLogsResponse>): FunctionsExecutorServiceUpdateLogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.acknowledged = false;
        message.logsReceived = 0;
        if (value !== undefined)
            reflectionMergePartial<FunctionsExecutorServiceUpdateLogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsExecutorServiceUpdateLogsResponse): FunctionsExecutorServiceUpdateLogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool acknowledged */ 1:
                    message.acknowledged = reader.bool();
                    break;
                case /* int32 logs_received */ 2:
                    message.logsReceived = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsExecutorServiceUpdateLogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool acknowledged = 1; */
        if (message.acknowledged !== false)
            writer.tag(1, WireType.Varint).bool(message.acknowledged);
        /* int32 logs_received = 2; */
        if (message.logsReceived !== 0)
            writer.tag(2, WireType.Varint).int32(message.logsReceived);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsExecutorServiceUpdateLogsResponse
 */
export const FunctionsExecutorServiceUpdateLogsResponse = new FunctionsExecutorServiceUpdateLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListLogsRequest$Type extends MessageType<FunctionsInvocationServiceListLogsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListLogsRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationServiceListLogsRequest>): FunctionsInvocationServiceListLogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.invocationId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationServiceListLogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationServiceListLogsRequest): FunctionsInvocationServiceListLogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string invocation_id */ 2:
                    message.invocationId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationServiceListLogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string invocation_id = 2; */
        if (message.invocationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invocationId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsRequest
 */
export const FunctionsInvocationServiceListLogsRequest = new FunctionsInvocationServiceListLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListLogsResponse$Type extends MessageType<FunctionsInvocationServiceListLogsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListLogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionLog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationServiceListLogsResponse>): FunctionsInvocationServiceListLogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationServiceListLogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationServiceListLogsResponse): FunctionsInvocationServiceListLogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.FunctionLog list */ 1:
                    message.list.push(FunctionLog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationServiceListLogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.FunctionLog list = 1; */
        for (let i = 0; i < message.list.length; i++)
            FunctionLog.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListLogsResponse
 */
export const FunctionsInvocationServiceListLogsResponse = new FunctionsInvocationServiceListLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetCommitRequest$Type extends MessageType<FunctionsServiceGetCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetCommitRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^(HEAD|[a-zA-Z0-9]{27}|refs/tags/[a-zA-Z0-9._-]+)$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceGetCommitRequest>): FunctionsServiceGetCommitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceGetCommitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceGetCommitRequest): FunctionsServiceGetCommitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceGetCommitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetCommitRequest
 */
export const FunctionsServiceGetCommitRequest = new FunctionsServiceGetCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceGetCommitResponse$Type extends MessageType<FunctionsServiceGetCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceGetCommitResponse", [
            { no: 1, name: "commit", kind: "message", oneof: "message", T: () => FunctionCommit },
            { no: 2, name: "file_chunk", kind: "message", oneof: "message", T: () => FileChunk }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceGetCommitResponse>): FunctionsServiceGetCommitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceGetCommitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceGetCommitResponse): FunctionsServiceGetCommitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.FunctionCommit commit */ 1:
                    message.message = {
                        oneofKind: "commit",
                        commit: FunctionCommit.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).commit)
                    };
                    break;
                case /* c1.api.functions.v1.FileChunk file_chunk */ 2:
                    message.message = {
                        oneofKind: "fileChunk",
                        fileChunk: FileChunk.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).fileChunk)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceGetCommitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.FunctionCommit commit = 1; */
        if (message.message.oneofKind === "commit")
            FunctionCommit.internalBinaryWrite(message.message.commit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.functions.v1.FileChunk file_chunk = 2; */
        if (message.message.oneofKind === "fileChunk")
            FileChunk.internalBinaryWrite(message.message.fileChunk, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceGetCommitResponse
 */
export const FunctionsServiceGetCommitResponse = new FunctionsServiceGetCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileChunk$Type extends MessageType<FileChunk> {
    constructor() {
        super("c1.api.functions.v1.FileChunk", [
            { no: 1, name: "filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "is_last_chunk", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<FileChunk>): FileChunk {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filename = "";
        message.data = new Uint8Array(0);
        message.isLastChunk = false;
        if (value !== undefined)
            reflectionMergePartial<FileChunk>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileChunk): FileChunk {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string filename */ 1:
                    message.filename = reader.string();
                    break;
                case /* bytes data */ 2:
                    message.data = reader.bytes();
                    break;
                case /* bool is_last_chunk */ 3:
                    message.isLastChunk = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileChunk, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string filename = 1; */
        if (message.filename !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.filename);
        /* bytes data = 2; */
        if (message.data.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.data);
        /* bool is_last_chunk = 3; */
        if (message.isLastChunk !== false)
            writer.tag(3, WireType.Varint).bool(message.isLastChunk);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FileChunk
 */
export const FileChunk = new FileChunk$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateInitialCommitRequest$Type extends MessageType<FunctionsServiceCreateInitialCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateInitialCommitRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "filenames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commit_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateInitialCommitRequest>): FunctionsServiceCreateInitialCommitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.filenames = [];
        message.commitMessage = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateInitialCommitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateInitialCommitRequest): FunctionsServiceCreateInitialCommitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* repeated string filenames */ 2:
                    message.filenames.push(reader.string());
                    break;
                case /* string commit_message */ 3:
                    message.commitMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceCreateInitialCommitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* repeated string filenames = 2; */
        for (let i = 0; i < message.filenames.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.filenames[i]);
        /* string commit_message = 3; */
        if (message.commitMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.commitMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitRequest
 */
export const FunctionsServiceCreateInitialCommitRequest = new FunctionsServiceCreateInitialCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateInitialCommitResponse$Type extends MessageType<FunctionsServiceCreateInitialCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse", [
            { no: 1, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "upload_urls", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateInitialCommitResponse>): FunctionsServiceCreateInitialCommitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.commitId = "";
        message.uploadUrls = {};
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateInitialCommitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateInitialCommitResponse): FunctionsServiceCreateInitialCommitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string commit_id */ 1:
                    message.commitId = reader.string();
                    break;
                case /* map<string, string> upload_urls */ 2:
                    this.binaryReadMap2(message.uploadUrls, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: FunctionsServiceCreateInitialCommitResponse["uploadUrls"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FunctionsServiceCreateInitialCommitResponse["uploadUrls"] | undefined, val: FunctionsServiceCreateInitialCommitResponse["uploadUrls"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse.upload_urls");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: FunctionsServiceCreateInitialCommitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string commit_id = 1; */
        if (message.commitId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.commitId);
        /* map<string, string> upload_urls = 2; */
        for (let k of globalThis.Object.keys(message.uploadUrls))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.uploadUrls[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateInitialCommitResponse
 */
export const FunctionsServiceCreateInitialCommitResponse = new FunctionsServiceCreateInitialCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFinalCommitRequest$Type extends MessageType<FunctionsServiceCreateFinalCommitRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFinalCommitRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateFinalCommitRequest>): FunctionsServiceCreateFinalCommitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.commitId = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateFinalCommitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateFinalCommitRequest): FunctionsServiceCreateFinalCommitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string commit_id */ 2:
                    message.commitId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceCreateFinalCommitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string commit_id = 2; */
        if (message.commitId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.commitId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitRequest
 */
export const FunctionsServiceCreateFinalCommitRequest = new FunctionsServiceCreateFinalCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateFinalCommitResponse$Type extends MessageType<FunctionsServiceCreateFinalCommitResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateFinalCommitResponse", [
            { no: 1, name: "commit", kind: "message", T: () => FunctionCommit }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateFinalCommitResponse>): FunctionsServiceCreateFinalCommitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateFinalCommitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateFinalCommitResponse): FunctionsServiceCreateFinalCommitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.FunctionCommit commit */ 1:
                    message.commit = FunctionCommit.internalBinaryRead(reader, reader.uint32(), options, message.commit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceCreateFinalCommitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.FunctionCommit commit = 1; */
        if (message.commit)
            FunctionCommit.internalBinaryWrite(message.commit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateFinalCommitResponse
 */
export const FunctionsServiceCreateFinalCommitResponse = new FunctionsServiceCreateFinalCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListCommitsRequest$Type extends MessageType<FunctionsServiceListCommitsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListCommitsRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceListCommitsRequest>): FunctionsServiceListCommitsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceListCommitsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceListCommitsRequest): FunctionsServiceListCommitsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceListCommitsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListCommitsRequest
 */
export const FunctionsServiceListCommitsRequest = new FunctionsServiceListCommitsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListCommitsResponse$Type extends MessageType<FunctionsServiceListCommitsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListCommitsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionCommit },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceListCommitsResponse>): FunctionsServiceListCommitsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceListCommitsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceListCommitsResponse): FunctionsServiceListCommitsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.FunctionCommit list */ 1:
                    message.list.push(FunctionCommit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceListCommitsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.FunctionCommit list = 1; */
        for (let i = 0; i < message.list.length; i++)
            FunctionCommit.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListCommitsResponse
 */
export const FunctionsServiceListCommitsResponse = new FunctionsServiceListCommitsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateTagRequest$Type extends MessageType<FunctionsServiceCreateTagRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateTagRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^(HEAD|[a-zA-Z0-9]{27}|refs/tags/[a-zA-Z0-9._-]+)$" } } } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "100", pattern: "^(refs/tags/)?[a-zA-Z0-9._-]+$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceCreateTagRequest>): FunctionsServiceCreateTagRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.commitId = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateTagRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateTagRequest): FunctionsServiceCreateTagRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string commit_id */ 2:
                    message.commitId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceCreateTagRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string commit_id = 2; */
        if (message.commitId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.commitId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateTagRequest
 */
export const FunctionsServiceCreateTagRequest = new FunctionsServiceCreateTagRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceCreateTagResponse$Type extends MessageType<FunctionsServiceCreateTagResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceCreateTagResponse", []);
    }
    create(value?: PartialMessage<FunctionsServiceCreateTagResponse>): FunctionsServiceCreateTagResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceCreateTagResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceCreateTagResponse): FunctionsServiceCreateTagResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceCreateTagResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceCreateTagResponse
 */
export const FunctionsServiceCreateTagResponse = new FunctionsServiceCreateTagResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListTagsRequest$Type extends MessageType<FunctionsServiceListTagsRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListTagsRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceListTagsRequest>): FunctionsServiceListTagsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceListTagsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceListTagsRequest): FunctionsServiceListTagsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceListTagsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListTagsRequest
 */
export const FunctionsServiceListTagsRequest = new FunctionsServiceListTagsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceListTagsResponse$Type extends MessageType<FunctionsServiceListTagsResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceListTagsResponse", [
            { no: 1, name: "tags", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FunctionCommit } }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceListTagsResponse>): FunctionsServiceListTagsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tags = {};
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceListTagsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceListTagsResponse): FunctionsServiceListTagsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.api.functions.v1.FunctionCommit> tags */ 1:
                    this.binaryReadMap1(message.tags, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: FunctionsServiceListTagsResponse["tags"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FunctionsServiceListTagsResponse["tags"] | undefined, val: FunctionsServiceListTagsResponse["tags"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FunctionCommit.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.functions.v1.FunctionsServiceListTagsResponse.tags");
            }
        }
        map[key ?? ""] = val ?? FunctionCommit.create();
    }
    internalBinaryWrite(message: FunctionsServiceListTagsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.api.functions.v1.FunctionCommit> tags = 1; */
        for (let k of globalThis.Object.keys(message.tags)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FunctionCommit.internalBinaryWrite(message.tags[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceListTagsResponse
 */
export const FunctionsServiceListTagsResponse = new FunctionsServiceListTagsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceInvokeRequest$Type extends MessageType<FunctionsServiceInvokeRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceInvokeRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "json", kind: "scalar", oneof: "arg", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceInvokeRequest>): FunctionsServiceInvokeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.commitId = "";
        message.arg = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceInvokeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceInvokeRequest): FunctionsServiceInvokeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string commit_id */ 2:
                    message.commitId = reader.string();
                    break;
                case /* bytes json */ 100:
                    message.arg = {
                        oneofKind: "json",
                        json: reader.bytes()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceInvokeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string commit_id = 2; */
        if (message.commitId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.commitId);
        /* bytes json = 100; */
        if (message.arg.oneofKind === "json")
            writer.tag(100, WireType.LengthDelimited).bytes(message.arg.json);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceInvokeRequest
 */
export const FunctionsServiceInvokeRequest = new FunctionsServiceInvokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsServiceInvokeResponse$Type extends MessageType<FunctionsServiceInvokeResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsServiceInvokeResponse", [
            { no: 1, name: "invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "json", kind: "scalar", oneof: "resp", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsServiceInvokeResponse>): FunctionsServiceInvokeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.invocationId = "";
        message.resp = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FunctionsServiceInvokeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsServiceInvokeResponse): FunctionsServiceInvokeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string invocation_id */ 1:
                    message.invocationId = reader.string();
                    break;
                case /* bytes json = 100 [deprecated = true] */ 100:
                    message.resp = {
                        oneofKind: "json",
                        json: reader.bytes()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsServiceInvokeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string invocation_id = 1; */
        if (message.invocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.invocationId);
        /* bytes json = 100 [deprecated = true]; */
        if (message.resp.oneofKind === "json")
            writer.tag(100, WireType.LengthDelimited).bytes(message.resp.json);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsServiceInvokeResponse
 */
export const FunctionsServiceInvokeResponse = new FunctionsServiceInvokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListRequest$Type extends MessageType<FunctionsInvocationServiceListRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationServiceListRequest>): FunctionsInvocationServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationServiceListRequest): FunctionsInvocationServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListRequest
 */
export const FunctionsInvocationServiceListRequest = new FunctionsInvocationServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceListResponse$Type extends MessageType<FunctionsInvocationServiceListResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionInvocation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationServiceListResponse>): FunctionsInvocationServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationServiceListResponse): FunctionsInvocationServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.FunctionInvocation list */ 1:
                    message.list.push(FunctionInvocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.FunctionInvocation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            FunctionInvocation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceListResponse
 */
export const FunctionsInvocationServiceListResponse = new FunctionsInvocationServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceGetRequest$Type extends MessageType<FunctionsInvocationServiceGetRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceGetRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationServiceGetRequest>): FunctionsInvocationServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationServiceGetRequest): FunctionsInvocationServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetRequest
 */
export const FunctionsInvocationServiceGetRequest = new FunctionsInvocationServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationServiceGetResponse$Type extends MessageType<FunctionsInvocationServiceGetResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationServiceGetResponse", [
            { no: 1, name: "invocation", kind: "message", T: () => FunctionInvocation }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationServiceGetResponse>): FunctionsInvocationServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationServiceGetResponse): FunctionsInvocationServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.functions.v1.FunctionInvocation invocation */ 1:
                    message.invocation = FunctionInvocation.internalBinaryRead(reader, reader.uint32(), options, message.invocation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.functions.v1.FunctionInvocation invocation = 1; */
        if (message.invocation)
            FunctionInvocation.internalBinaryWrite(message.invocation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationServiceGetResponse
 */
export const FunctionsInvocationServiceGetResponse = new FunctionsInvocationServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionInvocation$Type extends MessageType<FunctionInvocation> {
    constructor() {
        super("c1.api.functions.v1.FunctionInvocation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "input", kind: "message", T: () => Struct },
            { no: 7, name: "output", kind: "message", T: () => Struct },
            { no: 8, name: "status", kind: "enum", T: () => ["c1.api.functions.v1.FunctionInvocationStatus", FunctionInvocationStatus, "FUNCTION_INVOCATION_STATUS_"] },
            { no: 9, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionInvocation>): FunctionInvocation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.functionId = "";
        message.commitId = "";
        message.status = 0;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionInvocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionInvocation): FunctionInvocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string function_id */ 2:
                    message.functionId = reader.string();
                    break;
                case /* string commit_id */ 3:
                    message.commitId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Struct input */ 6:
                    message.input = Struct.internalBinaryRead(reader, reader.uint32(), options, message.input);
                    break;
                case /* google.protobuf.Struct output */ 7:
                    message.output = Struct.internalBinaryRead(reader, reader.uint32(), options, message.output);
                    break;
                case /* c1.api.functions.v1.FunctionInvocationStatus status */ 8:
                    message.status = reader.int32();
                    break;
                case /* string error */ 9:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionInvocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string function_id = 2; */
        if (message.functionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.functionId);
        /* string commit_id = 3; */
        if (message.commitId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.commitId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct input = 6; */
        if (message.input)
            Struct.internalBinaryWrite(message.input, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct output = 7; */
        if (message.output)
            Struct.internalBinaryWrite(message.output, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.functions.v1.FunctionInvocationStatus status = 8; */
        if (message.status !== 0)
            writer.tag(8, WireType.Varint).int32(message.status);
        /* string error = 9; */
        if (message.error !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionInvocation
 */
export const FunctionInvocation = new FunctionInvocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationSearchRequest$Type extends MessageType<FunctionsInvocationSearchRequest> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationSearchRequest", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationSearchRequest>): FunctionsInvocationSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationSearchRequest): FunctionsInvocationSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationSearchRequest
 */
export const FunctionsInvocationSearchRequest = new FunctionsInvocationSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionsInvocationSearchResponse$Type extends MessageType<FunctionsInvocationSearchResponse> {
    constructor() {
        super("c1.api.functions.v1.FunctionsInvocationSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionInvocation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionsInvocationSearchResponse>): FunctionsInvocationSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionsInvocationSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionsInvocationSearchResponse): FunctionsInvocationSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.functions.v1.FunctionInvocation list */ 1:
                    message.list.push(FunctionInvocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FunctionsInvocationSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.functions.v1.FunctionInvocation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            FunctionInvocation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.functions.v1.FunctionsInvocationSearchResponse
 */
export const FunctionsInvocationSearchResponse = new FunctionsInvocationSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsExecutorService
 */
export const FunctionsExecutorService = new ServiceType("c1.api.functions.v1.FunctionsExecutorService", [
    { name: "GetFunction", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceGetFunctionRequest, O: FunctionsExecutorServiceGetFunctionResponse },
    { name: "GetCommit", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceGetCommitRequest, O: FunctionsExecutorServiceGetCommitResponse },
    { name: "GetFunctionConfig", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceGetFunctionConfigRequest, O: FunctionsExecutorServiceGetFunctionConfigResponse },
    { name: "UpdateLogs", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsExecutorServiceUpdateLogsRequest, O: FunctionsExecutorServiceUpdateLogsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsService
 */
export const FunctionsService = new ServiceType("c1.api.functions.v1.FunctionsService", [
    { name: "GetFunction", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Function", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Function" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsServiceGetFunctionRequest, O: FunctionsServiceGetFunctionResponse },
    { name: "DeleteFunction", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/functions/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Function" }], group: "Function" }] }, "authz.method": { role: "EDITOR" } }, I: FunctionsServiceDeleteFunctionRequest, O: FunctionsServiceDeleteFunctionResponse },
    { name: "ListFunctions", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions", stability: "STABILITY_DRAFT", group: "Function" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsServiceListFunctionsRequest, O: FunctionsServiceListFunctionsResponse },
    { name: "CreateFunction", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Function" }], group: "Function" }] }, "authz.method": { role: "EDITOR" } }, I: FunctionsServiceCreateFunctionRequest, O: FunctionsServiceCreateFunctionResponse },
    { name: "UpdateFunction", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/update", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Function" }], group: "Function" }] }, "authz.method": { role: "EDITOR" } }, I: FunctionsServiceUpdateFunctionRequest, O: FunctionsServiceUpdateFunctionResponse },
    { name: "GetCommit", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: FunctionsServiceGetCommitRequest, O: FunctionsServiceGetCommitResponse },
    { name: "CreateInitialCommit", options: { "authz.method": { role: "EDITOR" } }, I: FunctionsServiceCreateInitialCommitRequest, O: FunctionsServiceCreateInitialCommitResponse },
    { name: "CreateFinalCommit", options: { "authz.method": { role: "EDITOR" } }, I: FunctionsServiceCreateFinalCommitRequest, O: FunctionsServiceCreateFinalCommitResponse },
    { name: "ListCommits", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/commits", stability: "STABILITY_DRAFT", group: "Function Commit" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsServiceListCommitsRequest, O: FunctionsServiceListCommitsResponse },
    { name: "CreateTag", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/{function_id}/tags", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Function_Tag" }], group: "Function Tag" }] }, "authz.method": { role: "EDITOR" } }, I: FunctionsServiceCreateTagRequest, O: FunctionsServiceCreateTagResponse },
    { name: "ListTags", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/tags", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Function_Tag" }], group: "Function Tag" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsServiceListTagsRequest, O: FunctionsServiceListTagsResponse },
    { name: "Invoke", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/{function_id}/invoke", stability: "STABILITY_DRAFT", group: "Function" }] }, "authz.method": { role: "OWNER" } }, I: FunctionsServiceInvokeRequest, O: FunctionsServiceInvokeResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsInvocationService
 */
export const FunctionsInvocationService = new ServiceType("c1.api.functions.v1.FunctionsInvocationService", [
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/invocations", stability: "STABILITY_DRAFT", group: "Function Invocation" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsInvocationServiceListRequest, O: FunctionsInvocationServiceListResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/functions/{function_id}/invocations/{id}", stability: "STABILITY_DRAFT", group: "Function Invocation" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsInvocationServiceGetRequest, O: FunctionsInvocationServiceGetResponse },
    { name: "ListLogs", options: { "authz.method": { role: "VIEWER" } }, I: FunctionsInvocationServiceListLogsRequest, O: FunctionsInvocationServiceListLogsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsInvocationSearchService
 */
export const FunctionsInvocationSearchService = new ServiceType("c1.api.functions.v1.FunctionsInvocationSearchService", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/functions/{function_id}/invocations/search", stability: "STABILITY_DRAFT", group: "Function Invocation" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsInvocationSearchRequest, O: FunctionsInvocationSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.functions.v1.FunctionsSearch
 */
export const FunctionsSearch = new ServiceType("c1.api.functions.v1.FunctionsSearch", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/functions", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Function", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Function" }] }, "authz.method": { role: "VIEWER" } }, I: FunctionsSearchRequest, O: FunctionsSearchResponse }
]);
